import { ParametroSistemaDto } from "./parametroSistemaDto.model";

export class UpdateParametroSistemaRequest {
  public parametrosSistema:ParametroSistemaDto[] = []
}
